const classNameInheritsAny = (
  className: string | null | undefined,
  parentMap: Record<string, string> | undefined,
  targets: Set<string>
): boolean => {
  let current = String(className || "").trim();
  const seen = new Set<string>();
  while (current && !seen.has(current)) {
    seen.add(current);
    if (targets.has(current.toLowerCase())) return true;
    current = String(parentMap?.[current] || "").trim();
  }
  return false;
};

export function shouldEmitSyntheticVisualForMeshCollisionAttrs(args: {
  mesh?: unknown;
  visualOnly?: unknown;
  className?: string | null;
  classParentMap?: Record<string, string>;
  group?: unknown;
  explicitMaterial?: string | null;
  inheritedMaterial?: unknown;
}): boolean {
  const mesh = typeof args.mesh === "string" ? args.mesh.trim() : "";
  if (!mesh) return false;
  const collisionRoleClasses = new Set(["collision", "eef_collision"]);
  const hiddenGeomGroup = Number.isFinite(Number(args.group)) && Number(args.group) >= 3;
  if (classNameInheritsAny(args.className, args.classParentMap, collisionRoleClasses)) {
    return false;
  }
  if (hiddenGeomGroup) return false;

  // `visualOnly` is derived from the effective MJCF contact masks after class
  // defaults are applied. If a mesh geom is effectively collidable, keep it in
  // the collision layer only; materials on collision geoms are common debugging
  // metadata and are not reliable visual intent.
  return false;
}

export const AMBIGUOUS_GEOM_ROLE_WARNING_PREFIX = "Ambiguous mesh geom role:";
